/**
 * Removes duplicate strings from an array.
 */
export function uniqStrings(strings) {
  var ourSet = {};
  for (var i = 0; i < strings.length; i++) {
    ourSet[strings[i]] = null;
  }
  return Object.keys(ourSet);
}